(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.closeModalSendEmailOrderTracking = closeModalSendEmailOrderTracking;
exports.priceCalculOALR = priceCalculOALR;
exports.toolsBoxCall = toolsBoxCall;
exports.pageOrder = pageOrder;
exports.zoomAccessoryOrderPage = zoomAccessoryOrderPage;
exports.paymentPage = paymentPage;
exports.loadTemplate = loadTemplate;
exports.uploadInformationAccordion = uploadInformationAccordion;
exports.dynamicPriceProductCard = dynamicPriceProductCard;
exports.selectsStatutNotification = selectsStatutNotification;
exports.verifSelectInputStatutNotification = verifSelectInputStatutNotification;
exports.inputsStatutNotification = inputsStatutNotification;
exports.showFloristSchedules = showFloristSchedules;
exports.updateFloristDeliveryLocationValue = updateFloristDeliveryLocationValue;

var _utils = require('./utils');

if (window.jQuery === undefined) {
    window.jQuery = window.$ = require('jquery');
}

function priceCalcul(currencyCurrent) {

    if ($('.product-data .value[data-attr="summary-product-amount"]').length) {
        priceCalculOALR(currencyCurrent);
        return false;
    }

    var accessoriesPrice = 0;
    var servicesPrice = 0;
    var priceProduct = "";
    var separator = (0, _utils.getSeparator)(currencyCurrent);
    var currency = (0, _utils.getCurrency)(currencyCurrent);
    var $deliveryPriceId = $('#delivery-price');
    var $discountPriceId = $('#discount-price');
    var $specialDeliveryPrice = $('#special-delivery-price');
    var $companyDiscount = $('#company-discount');
    var productPrices = '#form_order_checkout_productPrices';
    var deliveryPrice = parseFloat($deliveryPriceId.attr('data-delivery-price'));
    var productQuantityElement = document.querySelector('.js-product-quantity');
    var productQuantity = undefined === productQuantityElement || null === productQuantityElement ? 1 : parseInt(productQuantityElement.dataset.productQuantity, 10);

    priceProduct = $(productPrices + ' option').length ? parseFloat($(productPrices + ' option:selected').attr('data-size-price')) : parseFloat($(productPrices).attr('data-size-price'));

    var discountPrice = $discountPriceId.attr('data-discount-price') ? parseFloat($discountPriceId.attr('data-discount-price')) : 0;

    var discountDelivery = $specialDeliveryPrice.attr('data-special-delivery-price') ? parseFloat($specialDeliveryPrice.attr('data-special-delivery-price')) : 0;

    var companyDiscount = $companyDiscount.attr('data-company-discount-price') ? parseFloat($companyDiscount.attr('data-company-discount-price')) : 0;

    $('input[id*="accessory-"]').each(function () {
        if ($(this).is(':checked')) {
            accessoriesPrice = accessoriesPrice + parseFloat($(this).attr('data-acc-price'));
        }
    });

    document.querySelectorAll('.js-service').forEach(function (service) {
        if (service.checked && service.dataset.accPrice > 0) {
            servicesPrice = servicesPrice + parseFloat(service.dataset.accPrice);
        }
    });
    checkAndDisplayServiceTotalLine();

    var accessoryTotalLines = document.querySelectorAll(".js-order-product-accessory-line");
    accessoryTotalLines.forEach(function (accessoryTotalLine) {
        if (accessoryTotalLine) {
            if (accessoriesPrice > 0) {
                accessoryTotalLine.classList.remove('hidden-line');
            } else {
                accessoryTotalLine.classList.add('hidden-line');
            }
        }
    });

    checkAndDisplayAccessoryLines();

    var totalProductPrice = document.querySelector(".js-total-diy");
    var totalProductsCart = document.querySelector(".js-products-total-cart");

    if (null !== totalProductPrice) {
        priceProduct = parseFloat(totalProductPrice.dataset.totalProductPrice);
    } else {
        if (null !== totalProductsCart) {
            priceProduct = parseFloat(totalProductsCart.getAttribute('data-total-products-cart'));
        } else {
            priceProduct = priceProduct * productQuantity;
        }
    }

    var totalPrice = priceProduct + accessoriesPrice + servicesPrice + deliveryPrice - discountPrice - discountDelivery - companyDiscount;

    $('[data-switch="product-price"]').text(priceProduct.toFixed(2).replace('.', separator) + '\xa0' + currency);
    $('[data-switch="accessories-price"]').text(accessoriesPrice.toFixed(2).replace('.', separator) + '\xa0' + currency);
    if (document.querySelector('[data-switch="services-price"]')) {
        document.querySelector('[data-switch="services-price"]').textContent = servicesPrice.toFixed(2).replace('.', separator) + '\xa0' + currency;
    }
    $('[data-switch="total-price"]').text(totalPrice.toFixed(2).replace('.', separator) + '\xa0' + currency);
}

function closeModalSendEmailOrderTracking() {
    var buttonCloseSendMailConfirmationSelfcare = document.getElementById('close-modal-confirmation-selfcare');
    var backGroundModal = document.getElementById('background-modal-confirmation-send-mail-selfcare');
    var modalConfirmationSendMailSelcare = document.getElementById('modal-confirmation-mail-selfcare');
    if (buttonCloseSendMailConfirmationSelfcare !== null) {
        buttonCloseSendMailConfirmationSelfcare.addEventListener('click', function () {
            backGroundModal.style.display = 'none';
            modalConfirmationSendMailSelcare.style.display = 'none';
        });
    }
}

function updateHtmlPriceOALR(el, value, currencyCurrent) {
    var strAmount = value.toFixed(2).replace('.', (0, _utils.getSeparator)(currencyCurrent));
    el.childNodes[0].firstChild.textContent = (0, _utils.getCurrency)(currencyCurrent) + Math.trunc(strAmount);
    el.childNodes[0].lastChild.textContent = strAmount.substr(-3, 3);
}

function priceCalculOALR(currencyCurrent) {

    var $summaryOrderAmount = $('*[data-attr="summary-order-amount"]');
    var $summaryAccessoriesAmount = $('*[data-attr="summary-accessories-amount"]');
    var $summaryTaxAmount = $('*[data-attr="summary-tax-amount"]');
    var $inputsAccessory = $('input[id*="accessory-"]');
    var separator = (0, _utils.getSeparator)(currencyCurrent);
    var currency = (0, _utils.getCurrency)(currencyCurrent);
    var accessoriesPrice = 0;
    var discountDelivery = 0;
    var productPrice = parseFloat($('*[data-attr="summary-product-amount"]').attr('data-value'));
    var deliveryPrice = parseFloat($('*[data-attr="summary-delivery-amount"]').attr('data-value'));
    var discountPrice = parseFloat($('*[data-attr="summary-discount-amount"]').attr('data-value'));
    var orderAmount = parseFloat($summaryOrderAmount.attr('data-value'));

    productPrice = isNaN(productPrice) ? 0 : productPrice;
    deliveryPrice = isNaN(deliveryPrice) ? 0 : deliveryPrice;
    discountPrice = isNaN(discountPrice) ? 0 : discountPrice;

    $inputsAccessory.each(function () {
        if ($(this).is(':checked')) {
            accessoriesPrice = accessoriesPrice + parseFloat($(this).attr('data-acc-price'));
        }
    });

    var taxPrice = calculOALRTax(productPrice, accessoriesPrice, deliveryPrice);
    taxPrice = isNaN(taxPrice) ? 0 : taxPrice;

    orderAmount = productPrice + deliveryPrice + accessoriesPrice + taxPrice - discountPrice - discountDelivery;

    var elOrderAmount = document.querySelector('*[data-attr="summary-order-amount"]');
    var elAccessoriesAmount = document.querySelector('*[data-attr="summary-accessories-amount"]');
    var elTaxAmount = document.querySelector('*[data-attr="summary-tax-amount"]');

    updateHtmlPriceOALR(elTaxAmount, taxPrice, currencyCurrent);
    updateHtmlPriceOALR(elAccessoriesAmount, accessoriesPrice, currencyCurrent);
    updateHtmlPriceOALR(elOrderAmount, orderAmount, currencyCurrent);

    accessoriesPrice > 0 ? $summaryAccessoriesAmount.parent().removeClass('hide').show() : $summaryAccessoriesAmount.parent().hide();
}

function calculOALRTax(productPrice, accessoriesPrice, deliveryPrice) {
    return parseFloat(((productPrice + accessoriesPrice + deliveryPrice) * window.AQUA.TAX_RATE).toFixed(2));
}

function toolsBoxCall(currency) {
    var $deliveryPriceID = $('#delivery-price');
    var $toolboxClass = $('.toolbox-action.free-delivery');
    var $freeDelivery = $toolboxClass.find('i.js-state-action').hasClass('glyphicon-ok');
    var $saveDeliveryPrice = parseFloat($toolboxClass.find('.toolbox-save-delivery-price').val());
    var $saveDeliveryPriceColor = '';
    var $isMinimified = false;
    var fullSize = 0;
    var url = '';

    $toolboxClass.on('click', function () {
        $(this).find('i.js-state-action').toggleClass('glyphicon-remove').toggleClass('glyphicon-ok');
        $freeDelivery = !$freeDelivery;

        if ($freeDelivery) {
            $saveDeliveryPrice = $deliveryPriceID.attr('data-delivery-price');
            $saveDeliveryPriceColor = $deliveryPriceID.css('color');
            $deliveryPriceID.attr('data-delivery-price', '0.00');
            $deliveryPriceID.css('color', 'red').html('0.00 €');
            priceCalcul(currency);
        } else {
            $deliveryPriceID.attr('data-delivery-price', $saveDeliveryPrice);
            $deliveryPriceID.css('color', $saveDeliveryPriceColor).html($saveDeliveryPrice + ' €');
            priceCalcul(currency);
        }

        url = $(this).find('input.toolbox-action-path').val();

        $.post(url);
    });

    var toolboxTitle = '.js-toolbox-title';
    var toolboxMiniHide = '.js-toolbox-mini-hide';
    var toolboxMiniShow = '.js-toolbox-mini-show';

    $(".call-toolbox .js-toolbox-resize").on('click', function () {

        $(this).find('i').toggleClass('glyphicon-minus').toggleClass('glyphicon-plus');
        if (!$isMinimified && fullSize === 0) fullSize = $(this).parent().css('width');
        $isMinimified = !$isMinimified;

        if ($isMinimified) {
            $(toolboxTitle).hide();
            $(toolboxMiniHide).hide();
            $(toolboxMiniShow).show();
            $(this).parent().css('width', '100px');
        } else {
            $(toolboxTitle).show();
            $(toolboxMiniHide).show();
            $(toolboxMiniShow).hide();
            $(this).parent().css('width', fullSize);
        }
    });

    $('[data-toggle="tooltip"]').tooltip();

    $(".js-summary-hide").on('click', function () {
        $('.form-accessories').toggle();
        $(this).find('i').toggleClass('glyphicon-triangle-right').toggleClass('glyphicon-triangle-bottom');
    });

    $(".js-composition-hide").on('click', function () {
        $('.diy-product-list-summary').toggle();
        $(this).find('i').toggleClass('glyphicon-triangle-right').toggleClass('glyphicon-triangle-bottom');
    });
}

function pageOrder(formProductPrices, inputAccessory, currency) {

    // Select
    $(formProductPrices).on('change', function () {
        priceCalcul(currency);
    });

    // Input accessory
    $(inputAccessory).on('click', function () {
        priceCalcul(currency);
    });

    // Input service
    document.querySelectorAll('.js-service').forEach(function (service) {
        service.addEventListener('click', function () {
            priceCalcul(currency);
        });
    });
    checkAndDisplayServiceTotalLine();

    // Florist order checkout missing delivery explanation
    var floristMissingDeliveryLink = document.querySelector('.js-form-group-order-recipient-florist-city-missing-link');
    var floristMissingDeliveryBlock = document.querySelector('.js-form-group-order-recipient-florist-city-missing');
    var floristDeliveryExplanationBlock = document.querySelector('.js-form-group-order-recipient-florist-city-explanation');
    if (floristMissingDeliveryLink && floristMissingDeliveryBlock && floristDeliveryExplanationBlock) {
        floristMissingDeliveryLink.addEventListener('click', function () {
            floristMissingDeliveryBlock.style.display = 'none';
            floristDeliveryExplanationBlock.style.display = 'block';
        });
    }

    // Message field suggestion with loco keys
    var messageLocoField = document.querySelector('.js-message');
    var messageLocoSuggestionField = document.querySelector('.js-form-suggestion-loco-message');

    if (messageLocoField && messageLocoSuggestionField) {
        messageLocoSuggestionField.addEventListener("change", function () {
            messageLocoField.value = this.value;
        });
    }

    // Default Bootstrap radio button style
    checkAndChangeClassForDeliveryTypeFields();

    // Check accessories previously selected
    checkAndDisplayAccessoryLines();

    // Funeral message checkbox
    var funeralMessageField = document.querySelector('.js-funeral-message-field');
    var funeralMessageCheckbox = document.querySelector('.js-funeral-message-checkbox');
    if (funeralMessageField && funeralMessageCheckbox) {
        funeralMessageCheckbox.addEventListener('change', function () {
            if (!funeralMessageCheckbox.checked) {
                funeralMessageField.value = '';
            }
        });
        funeralMessageField.addEventListener('change', function () {
            if (!funeralMessageCheckbox.checked) {
                funeralMessageCheckbox.checked = true;
            }
        });
    }

    // Clear anonymous field
    var messageSuggestionField = document.querySelector('.js-form-suggestion-message');
    var messageField = document.querySelector('.js-form-message');
    var signatureField = document.querySelector('.js-form-signature');
    var anonymousField = document.querySelector('.js-form-anonymous input');

    if (messageSuggestionField && anonymousField && anonymousField.checked) {
        messageSuggestionField.addEventListener('change', function () {
            anonymousField.checked = false;
        });
    }
    if (messageField && anonymousField && anonymousField.checked) {
        messageField.addEventListener('keydown', function () {
            anonymousField.checked = false;
        });
    }
    if (signatureField && anonymousField && anonymousField.checked) {
        signatureField.addEventListener('keydown', function () {
            anonymousField.checked = false;
        });
    }
    if (messageSuggestionField && messageField && signatureField && anonymousField) {
        anonymousField.addEventListener('change', function () {
            if (anonymousField.checked) {
                messageSuggestionField.value = '';
                messageField.value = '';
                signatureField.value = '';
            }
        });
    }

    // AJAX planning dropdown select
    var planningDay = document.querySelector('.js-form-planning-day');
    if (planningDay) {
        planningDay.addEventListener('change', function () {
            var form = planningDay.closest('form');
            var formData = new FormData();
            formData.append(planningDay.getAttribute('name'), planningDay.value);
            fetch(form.action, {
                method: form.getAttribute('method'),
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(function (response) {
                return response.text();
            }).then(function (htmlResponse) {
                var htmlDOM = new DOMParser().parseFromString(htmlResponse.toString(), 'text/html');
                checkAndReplaceQuerySelector('.js-form-planning-time-slot', htmlDOM);
            });
        });
    }

    window.addEventListener("load", function () {
        // Add a keyup event listener to zip code input element
        var nameZipCodeInput = document.querySelector('.js-form-autocomplete-recipient-zip-code');
        if (nameZipCodeInput) {
            nameZipCodeInput.addEventListener("keyup", function (event) {
                autocompleteCity(event, document.querySelector('.js-form-autocomplete-results-zip-code'), 'autocomplete-results-zip-code-item', document.querySelector('.js-form-autocomplete-recipient-city'), document.querySelector('.js-form-autocomplete-recipient-zip-code'), 'data-city', 'data-zip-code', false);
            });
        }

        // Add a keyup event listener to city input element
        var nameCityInput = document.querySelector('.js-form-autocomplete-recipient-city');
        if (nameCityInput) {
            nameCityInput.addEventListener("keyup", function (event) {
                autocompleteCity(event, document.querySelector('.js-form-autocomplete-results-city'), 'autocomplete-results-city-item', document.querySelector('.js-form-autocomplete-recipient-zip-code'), document.querySelector('.js-form-autocomplete-recipient-city'), 'data-zip-code', 'data-city', true);
            });
        }

        // create one global XHR object
        // so we can abort old requests when a new one is make
        window.hinterXHR = new XMLHttpRequest();
    });

    var resultsZipCode = document.querySelector('.js-form-autocomplete-results-zip-code');
    var resultsCity = document.querySelector('.js-form-autocomplete-results-city');
    autocompleteMouseLeave(resultsZipCode);
    autocompleteMouseLeave(resultsCity);

    var deliveryTypes = document.querySelectorAll('.js-form-delivery-type');
    var deliveryToGraveCheckbox = document.querySelector('.js-delivery-to-grave-checkbox');
    var planningTimeSlotField = document.querySelector('.js-form-planning-time-slot');
    var recipientNameField = document.querySelector('.js-form-recipient-name');

    if (deliveryToGraveCheckbox) {
        deliveryTypes.forEach(function (deliveryType) {
            var deliveryTypeRadio = deliveryType.querySelector('.js-form-delivery-type-radio');
            if (AQUA.FUNERAL_DELIVERY_TYPE_CEMETERY === deliveryTypeRadio.value && deliveryTypeRadio.checked) {
                if (!deliveryToGraveCheckbox.checked) {
                    deliveryToGraveCheckbox.checked = true;
                    checkAndDisplayAccessoryLines();
                }
                changeCheckboxReadOnlyAttribute(deliveryToGraveCheckbox, true);
            }
            if (planningTimeSlotField && !planningTimeSlotField.value && deliveryTypeRadio.checked) {
                ajaxDeliveryTypesBuildForm(deliveryType, deliveryTypeRadio);
            }
            if (deliveryTypeRadio.checked) {
                // change funeral labels for chosen delivery type
                changeFuneralLabel(deliveryTypeRadio.value, 'hour');
                changeFuneralLabel(deliveryTypeRadio.value, 'defunct');
                changeFuneralLabel(deliveryTypeRadio.value, 'address');
                changeFuneralLabel(deliveryTypeRadio.value, 'phone');
                changeFuneralLabel(deliveryTypeRadio.value, 'planning-day-label');
            }

            // check is delivery to grave checked on product page (AQCOM)
            if (deliveryToGraveCheckbox.checked && AQUA.FUNERAL_DELIVERY_TYPE_CEMETERY === deliveryTypeRadio.value && !deliveryTypeRadio.checked && !planningTimeSlotField && recipientNameField && !recipientNameField.value) {
                changeCheckboxReadOnlyAttribute(deliveryToGraveCheckbox, true);
                deliveryTypeRadio.checked = true;
                checkAndChangeClassForDeliveryTypeFields();

                //re-build form with ajax after delivery type change
                ajaxDeliveryTypesBuildForm(deliveryType, deliveryTypeRadio);
            }
        });

        deliveryToGraveCheckbox.addEventListener('click', function () {
            changeCheckboxReadOnlyAttribute(deliveryToGraveCheckbox, true);
        });
    }

    // AJAX planning delivery type select
    if (deliveryTypes) {
        deliveryTypes.forEach(function (deliveryType) {
            deliveryType.addEventListener('click', function () {
                var deliveryTypeRadio = deliveryType.querySelector('.js-form-delivery-type-radio');

                //disable/enable accessory checkboxes
                if (deliveryTypeRadio && deliveryToGraveCheckbox) {
                    deliveryToGraveCheckbox.checked = !!(AQUA.FUNERAL_DELIVERY_TYPE_CEMETERY === deliveryTypeRadio.value && deliveryToGraveCheckbox);
                    if (AQUA.FUNERAL_DELIVERY_TYPE_CEMETERY === deliveryTypeRadio.value && deliveryToGraveCheckbox) {
                        changeCheckboxReadOnlyAttribute(deliveryToGraveCheckbox, true);
                    } else {
                        changeCheckboxReadOnlyAttribute(deliveryToGraveCheckbox, false);
                    }
                }
                checkAndDisplayAccessoryLines();

                // reinitialize date field
                var planningDayLabel = document.querySelector('.js-form-planning-day');
                if (planningDayLabel) {
                    planningDayLabel.value = '';
                }

                // re-build form with ajax after delivery type change
                ajaxDeliveryTypesBuildForm(deliveryType, deliveryTypeRadio);

                // update prices
                priceCalcul(currency);
            });

            var deliveryTypeRadio = deliveryType.querySelector('.js-form-delivery-type-radio');
            if (deliveryToGraveCheckbox && AQUA.FUNERAL_DELIVERY_TYPE_CEMETERY === deliveryTypeRadio.value) {
                deliveryToGraveCheckbox.addEventListener('click', function () {
                    if (deliveryToGraveCheckbox.checked) {
                        deliveryTypeRadio.checked = true;

                        //re-build form with ajax after delivery type change
                        ajaxDeliveryTypesBuildForm(deliveryType, deliveryTypeRadio);

                        // Update Bootstrap radio button style
                        checkAndChangeClassForDeliveryTypeFields();
                    }
                });
            }
        });
    }
}

function zoomAccessoryOrderPage(eventZoom) {
    $(eventZoom).on('show.bs.modal', function (e) {
        var acc = e.relatedTarget;
        var img = $(acc).attr('data-zoom');
        var id = $(acc).attr('data-id');
        // let input= $(acc).parent().parent().prev().find("input[type='checkbox']");
        var input = $("#" + id);

        var txtButton = '';
        var contentHtml = '';

        if ($(input).is(':disabled')) {
            $(eventZoom + ' a').hide();
        } else {
            $(eventZoom + ' a').show();

            $(input).is(':checked') ? txtButton = window.AQUA.PRODUCT.TRANSLATIONS.REMOVE_ACCESSORIES : txtButton = window.AQUA.PRODUCT.TRANSLATIONS.ADD_ACCESSORIES;

            $(eventZoom + ' a').html(txtButton);
        }

        contentHtml += '<img src="' + img + '" width="550" height="550">\n                        <input type="hidden" value="' + $(input).val() + '"/>';

        $(eventZoom + ' .accessory').html(contentHtml);
    });

    $(eventZoom + ' a').on('click', function () {
        var id = $(this).parent().find('input[type="hidden"]').val();
        var input = "input[value='" + id + "'";

        if (id !== undefined && !$(input).is(':disabled')) {
            $(input).trigger('click');
        }

        $(eventZoom).modal('hide');
    });

    $(eventZoom).on('hidden.bs.modal', function () {
        $(eventZoom + ' .accessory').html('');
    });
}

function paymentPage() {

    var $modalValidateVoucherID = $('#modal-validate-voucher');
    var $paymentTypeCardCLass = $('.payment-type-card');
    var $validVoucherPayment = $('#valid-voucher-payment');

    if ($modalValidateVoucherID.length > 0) {
        $modalValidateVoucherID.modal();
    }

    $validVoucherPayment.on('click', function () {
        $modalValidateVoucherID.modal('hide');
    });

    // Payment color
    $paymentTypeCardCLass.on('click', function () {
        $paymentTypeCardCLass.each(function () {
            if ($(this).hasClass('active')) $(this).removeClass('active');
        });
        $(this).toggleClass('active');
    });
}

function loadTemplate(stringJson) {
    var $content = $('#form_order_checkout_message');
    var message = '';

    $.getJSON(stringJson, {
        format: "json"
    }).done(function (data) {
        message = data;
        chargeMessage(message);
    });

    $('#suggestion_mess').on('change', function () {
        var id_mess = $(this).val();
        $content.html(message.message[id_mess]);
        $content.val(message.message[id_mess]);
    });
}

function chargeMessage(data) {
    var category = data.type;
    var selectBox = $('#suggestion_mess');

    $.each(category, function (i) {
        if ((undefined === window.AQUA.FUNERAL_PRODUCT || '' === window.AQUA.FUNERAL_PRODUCT) && 'DEUIL' !== category[i].titre) {
            selectBox.append('<option disabled="disabled" value="-1">-----------------------</option>');
            selectBox.append('<optgroup label="' + category[i].titre + '">');
        }
        if ((undefined === window.AQUA.FUNERAL_PRODUCT || '' === window.AQUA.FUNERAL_PRODUCT) && 'DEUIL' !== category[i].titre || '' !== window.AQUA.FUNERAL_PRODUCT && 'DEUIL' === category[i].titre) {
            var list = category[i].liste;
            $.each(list, function (x) {
                selectBox.append('<option value="' + list[x].i + '">' + list[x].t + '</option>');
            });
            selectBox.append('</optgroup>');
        }
    });
}

function uploadInformationAccordion() {
    var uploadTypes = [{ origin: '.upload-photo__carret', target: '.upload-photo__info' }, { origin: '.upload-video__carret', target: '.upload-video__info' }, { origin: '.accessories-list__carret', target: '.accessories-list__info' }, { origin: '.accessories-list-mobile__carret', target: '.accessories-list-mobile__info' }, { origin: '.total-list__carret', target: '.total-list__info' }];

    uploadTypes.forEach(function (uploadType) {
        return $(uploadType.origin).on('click', function () {
            if ($(this).hasClass('active')) {
                $(uploadType.origin).removeClass('active');
                $(uploadType.target).removeClass('active');
            } else {
                (0, _utils.ufToggleClassElement)('active', [$(this), $(this).attr('data-target')]);
            }
        });
    });
}

function dynamicPriceProductCard() {
    var isProductDIYDynamicPrice = document.querySelector('.js-diy-dynamic-price');
    if (!isProductDIYDynamicPrice) {
        return;
    }

    var products = document.querySelectorAll('.js-component-price');
    var totalProductPrice = document.querySelector('.js-total-diy');
    var productRemoved = document.querySelectorAll('.js-product-remove');

    window.addEventListener('DOMContentLoaded', function () {
        calculProductsPrice(products, totalProductPrice);
    });

    products.forEach(function (productCard) {
        productCard.addEventListener('change', function (event) {
            priceCalcul(window.AQUA.INIT_CURRENCY);
        });
    });

    productRemoved.forEach(function (product) {
        product.addEventListener('click', function (event) {
            var selectedProduct = product.dataset.product;
            var select = document.querySelector(".js-select-" + selectedProduct);
            product.parentElement.dataset.totalPrice = 0;
            product.parentElement.classList.add('hidden');
            select.selectedIndex = 0;
            calculProductsPrice(products, totalProductPrice);
        });
    });
}

function selectsStatutNotification(jsclass) {

    if (jsclass) {
        jsclass.addEventListener('change', function () {
            if (this.value == "") {
                jsclass.classList.remove("select--valid");
                jsclass.classList.add("select--invalid");
            } else {
                jsclass.classList.remove("select--invalid");
                jsclass.classList.add("select--valid");
            }
        });
    }
}

function verifSelectInputStatutNotification() {

    var btnSummit = document.querySelectorAll('.js-button-green');
    btnSummit.forEach(function (elt) {

        elt.addEventListener('click', function (event) {

            var selectsRequired = document.querySelectorAll('select[required]');
            var inputsRequired = document.querySelectorAll('input[required]');

            selectsRequired.forEach(function (selectRequired) {
                selectRequired.value == "" ? selectRequired.classList.add("select--invalid") : null;
            });

            inputsRequired.forEach(function (inputRequired) {
                if (inputRequired.value.length == 0) {
                    inputRequired.classList.add("input--invalid");
                }
            });
        });
    });
}

function inputsStatutNotification() {
    var inputs = document.querySelectorAll("[type='text'][required], [type='tel'], [type='email'] ");
    inputs.forEach(function (elt) {

        elt.addEventListener('input', function (event) {
            event.currentTarget.classList.remove('input--valid', 'input--invalid');
            event.currentTarget.value.length > 0 ? event.currentTarget.classList.add("input--valid") : event.currentTarget.classList.add("input--invalid");
        });

        elt.addEventListener('focusout', function (event) {
            var isValidInput = void 0;
            switch (event.currentTarget.type) {
                case 'text':
                    isValidInput = event.currentTarget.value.length !== 0;
                    break;
                case 'tel':
                    if (window.intlTelInputGlobals) {
                        var iti = window.intlTelInputGlobals.getInstance(event.currentTarget);
                        isValidInput = iti.isValidNumber();
                    }
                    break;
                case 'email':
                    var mailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    isValidInput = mailRegex.test(event.currentTarget.value.toLowerCase());
                    break;
                default:
            }

            event.currentTarget.classList.remove('input--valid', 'input--invalid');
            isValidInput ? event.currentTarget.classList.add("input--valid") : event.currentTarget.classList.add("input--invalid");
        });
    });
}

function ajaxDeliveryTypesBuildForm(deliveryType, deliveryTypeRadio) {
    var form = deliveryType.closest('form');
    var formData = new FormData();
    formData.append(deliveryTypeRadio.getAttribute('name'), deliveryTypeRadio.value);
    fetch(form.action, {
        method: form.getAttribute('method'),
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(function (response) {
        return response.text();
    }).then(function (htmlResponse) {
        var htmlDOM = new DOMParser().parseFromString(htmlResponse.toString(), 'text/html');
        checkAndReplaceQuerySelector('.js-form-group-planning-time-slot', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-group-funeral-hour', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-title', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-name', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-first-name', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-address', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-additional-address', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-door-code', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-second-door-code', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-stair', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-floor', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-instruction', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-save-address', htmlDOM);

        if (document.querySelector('.js-form-group-recipient-additional-address') && document.querySelector('.js-form-group-recipient-address')) {
            if (AQUA.FUNERAL_DELIVERY_TYPE_RESIDENCE === deliveryTypeRadio.value) {
                document.querySelector('.js-form-group-recipient-address').after(document.querySelector('.js-form-group-recipient-additional-address'));
            } else {
                document.querySelector('.js-form-group-recipient-additional-address').after(document.querySelector('.js-form-group-recipient-address'));
            }
        }

        // change funeral labels for chosen delivery type
        changeFuneralLabel(deliveryTypeRadio.value, 'hour');
        changeFuneralLabel(deliveryTypeRadio.value, 'defunct');
        changeFuneralLabel(deliveryTypeRadio.value, 'address');
        changeFuneralLabel(deliveryTypeRadio.value, 'phone');
        changeFuneralLabel(deliveryTypeRadio.value, 'planning-day-label');
    });
}

// Autocomplete for form
function autocompleteCity(event, dataList, autoCompleteResultsItemClass, sourceField, destinationField, sourceQualifierName, destinationQualifierName, isCitySource) {

    // retrieve the input element
    var input = event.target;

    // minimum number of characters before we start to generate suggestions
    var minCharacters = 4;

    if (input.value.length >= minCharacters) {

        // abort any pending requests
        window.hinterXHR.abort();

        window.hinterXHR.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {

                // We're expecting a json response so we convert it to an object
                var response = JSON.parse(this.responseText);
                if (dataList) {
                    // clear any previously loaded options in the datalist
                    dataList.innerHTML = "";
                    if (response && response.length > 0) {
                        response.forEach(function (item) {
                            dataList.innerHTML += '<li>' + '<a class="' + autoCompleteResultsItemClass + '" data-city="' + item.name + '" data-zip-code="' + item.zip_code + '">' + (isCitySource ? item.name + ' (' + item.zip_code + ')' : item.zip_code + ' - ' + item.name) + '</a></li>';
                        });
                    }

                    var autocompleteResultsItems = document.querySelectorAll('.' + autoCompleteResultsItemClass);
                    if (autocompleteResultsItems) {
                        autocompleteResultsItems.forEach(function (autocompleteResultsItem) {
                            autocompleteResultsItem.addEventListener('click', function (event) {
                                sourceField.value = autocompleteResultsItem.getAttribute(sourceQualifierName);
                                destinationField.value = autocompleteResultsItem.getAttribute(destinationQualifierName);
                                dataList.style.display = 'none';
                            });
                        });
                    }
                    dataList.style.display = 'block';
                }
            }
        };

        window.hinterXHR.open("GET", "/autocomplete-city/" + input.value, true);
        window.hinterXHR.send();
    }
}

function autocompleteMouseLeave(fieldResults) {
    if (fieldResults) {
        fieldResults.addEventListener("mouseleave", function (event) {
            fieldResults.style.display = 'none';
        }, false);
    }
}

function calculProductsPrice(products, totalProductPrice) {
    var productPrice = 0;

    products.forEach(function (product) {
        productPrice += parseFloat(product.dataset.totalPrice);
    });

    if (totalProductPrice) {
        totalProductPrice.dataset.totalProductPrice = productPrice;
        totalProductPrice.innerHTML = (0, _utils.getFormatedPrice)(window.AQUA.LOCALE, (0, _utils.getCurrency)(window.AQUA.INIT_CURRENCY), parseFloat(productPrice).toFixed(2).replace(".", ","));
        priceCalcul(window.AQUA.INIT_CURRENCY);
    }
}

function changeFuneralLabel(deliveryTypeRadioValue, field) {
    var currentFuneralText = document.querySelector('.js-funeral-' + deliveryTypeRadioValue + '-' + field + '-text');
    var funeralTexts = document.querySelectorAll('.js-funeral-' + field + '-text');
    if (funeralTexts) {
        funeralTexts.forEach(function (funeralText) {
            funeralText.classList.add('hidden');
        });
    }
    if (currentFuneralText) {
        currentFuneralText.classList.remove('hidden');
    }
}

function checkAndChangeClassForDeliveryTypeFields() {
    var deliveryTypeFields = document.querySelectorAll('.js-form-delivery-type');
    deliveryTypeFields.forEach(function (deliveryTypeField) {
        deliveryTypeField.classList.remove('active');
        if (deliveryTypeField) {
            for (var i = 0; i < deliveryTypeField.childNodes.length; i++) {
                if (deliveryTypeField.childNodes[i].checked) {
                    deliveryTypeField.classList.add('active');
                }
            }
        }
    });
}

function checkAndDisplayAccessoryLines() {
    var accessoryLines = document.querySelectorAll(".js-accessory-line");
    accessoryLines.forEach(function (accessoryLine) {
        var accessorySelector = document.querySelector('input[id="accessory-' + accessoryLine.getAttribute('data-accessory-id') + '"]');
        if (undefined !== accessorySelector && accessorySelector.checked) {
            accessoryLine.classList.remove('hidden');
        } else {
            accessoryLine.classList.add('hidden');
        }
    });
}

function checkAndReplaceQuerySelector(selector, htmlDOM) {
    if (document.querySelector(selector) && htmlDOM.querySelector(selector)) {
        // Don't add form error class for ajax field replacement
        var DOMInputElements = htmlDOM.querySelectorAll('input');
        DOMInputElements.forEach(function (DOMInputElement) {
            if (undefined !== DOMInputElement.classList) {
                DOMInputElement.classList.remove('has-error');
            }
        });
        // Replace field
        document.querySelector(selector).replaceWith(htmlDOM.querySelector(selector));
    }
}

function changeCheckboxReadOnlyAttribute(checkbox, isActivated) {
    checkbox.readOnly = isActivated;
    checkbox.labels.forEach(function (label) {
        if (isActivated) {
            label.setAttribute('readOnly', 'readonly');
        } else {
            label.removeAttribute('readOnly');
        }
    });
}

// show hidden schedules block (florist delivery choice page)
function showFloristSchedules() {

    var schedulesBlock = document.querySelector(".js-florist-information-schedules");
    var schedulesBlockHidden = document.querySelector(".js-florist-information-schedules-hidden");

    if (schedulesBlock) {
        schedulesBlock.addEventListener('click', function (event) {
            schedulesBlock.remove();
            schedulesBlockHidden.style.display = "inline";
        });
    }
}

//Florist delivery choice events
function updateFloristDeliveryLocationValue() {
    var floristDeliveryChoiceFormChoices = document.querySelectorAll('.js-florist-delivery-choice-form-choice');
    var floristDeliveryChoiceFormChoiceFlorist = document.querySelector('.js-florist-delivery-choice-form-choice-florist');
    var floristDeliveryChoiceFormDeliveryLocation = document.querySelector('.js-florist-delivery-choice-form-delivery-location');

    if (floristDeliveryChoiceFormChoices && floristDeliveryChoiceFormChoiceFlorist && floristDeliveryChoiceFormDeliveryLocation) {
        floristDeliveryChoiceFormChoices.forEach(function (floristDeliveryChoiceFormChoice) {
            floristDeliveryChoiceFormChoice.addEventListener("click", function () {
                floristDeliveryChoiceFormDeliveryLocation.value = '';
            });
        });
        floristDeliveryChoiceFormDeliveryLocation.addEventListener("change", function () {
            floristDeliveryChoiceFormChoiceFlorist.checked = true;
        });
    }
}

function checkAndDisplayServiceTotalLine() {
    if (document.querySelector('[data-switch="services-price"]')) {
        var servicesPrice = 0;

        document.querySelectorAll('.js-service').forEach(function (service) {
            if (service.checked && service.dataset.accPrice > 0) {
                servicesPrice = servicesPrice + parseFloat(service.dataset.accPrice);
            }
        });

        var parentNode = (0, _utils.getParentNode)(document.querySelector('[data-switch="services-price"]'), 'table-summary-line');
        if (parentNode !== false) {
            if (servicesPrice === 0) {
                parentNode.style.display = "none";
            } else {
                parentNode.style.display = "table";
            }
        }
    }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{"./utils":3,"jquery":6}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var toggleMoreAndLess = function toggleMoreAndLess(height) {
    'use strict';

    var els = {};

    /**
     * Cache DOM elements
     **/
    var dom = function dom() {
        els.toggleMoreContent = document.querySelector('.js-toggle-more-content');
        els.toggleMoreBtn = document.querySelector('.js-toggle-more-btn');
        els.toggleLessBtn = document.querySelector('.js-toggle-less-btn');
    };

    /**
     * Bind events
     **/
    var bind = function bind() {
        if (els.toggleMoreContent && els.toggleMoreContent.clientHeight <= height && els.toggleMoreBtn && els.toggleLessBtn) {
            els.toggleMoreBtn.style.display = 'none';
            els.toggleLessBtn.style.display = 'none';
        }
        if (els.toggleMoreContent && els.toggleMoreContent.clientHeight > height && els.toggleMoreBtn && els.toggleLessBtn) {
            els.toggleMoreBtn.addEventListener("click", function () {
                els.toggleMoreBtn.previousElementSibling.style.overflow = 'none';
                els.toggleMoreBtn.previousElementSibling.style.height = 'auto';
                els.toggleMoreBtn.style.display = 'none';
                els.toggleLessBtn.style.display = 'block';
            });
            els.toggleLessBtn.addEventListener("click", function () {
                els.toggleLessBtn.previousElementSibling.previousElementSibling.style.height = height + 'px';
                els.toggleLessBtn.previousElementSibling.previousElementSibling.style.overflow = 'hidden';
                els.toggleLessBtn.style.display = 'none';
                els.toggleMoreBtn.style.display = 'block';
            });
        }
    };

    /**
     * Initialize the module
     */
    var init = function init() {
        dom();
        bind();
    };

    init();
};
exports.default = toggleMoreAndLess;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRvZ2dsZU1vcmVBbmRMZXNzLmpzIl0sIm5hbWVzIjpbInRvZ2dsZU1vcmVBbmRMZXNzIiwiaGVpZ2h0IiwiZWxzIiwiZG9tIiwidG9nZ2xlTW9yZUNvbnRlbnQiLCJkb2N1bWVudCIsInF1ZXJ5U2VsZWN0b3IiLCJ0b2dnbGVNb3JlQnRuIiwidG9nZ2xlTGVzc0J0biIsImJpbmQiLCJjbGllbnRIZWlnaHQiLCJzdHlsZSIsImRpc3BsYXkiLCJhZGRFdmVudExpc3RlbmVyIiwicHJldmlvdXNFbGVtZW50U2libGluZyIsIm92ZXJmbG93IiwiaW5pdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxJQUFNQSxvQkFBb0IsU0FBcEJBLGlCQUFvQixDQUFDQyxNQUFELEVBQVk7QUFDbEM7O0FBQ0EsUUFBSUMsTUFBTSxFQUFWOztBQUVBOzs7QUFHQSxRQUFNQyxNQUFNLFNBQU5BLEdBQU0sR0FBTTtBQUNkRCxZQUFJRSxpQkFBSixHQUF3QkMsU0FBU0MsYUFBVCxDQUF1Qix5QkFBdkIsQ0FBeEI7QUFDQUosWUFBSUssYUFBSixHQUFvQkYsU0FBU0MsYUFBVCxDQUF1QixxQkFBdkIsQ0FBcEI7QUFDQUosWUFBSU0sYUFBSixHQUFvQkgsU0FBU0MsYUFBVCxDQUF1QixxQkFBdkIsQ0FBcEI7QUFDSCxLQUpEOztBQU1BOzs7QUFHQSxRQUFNRyxPQUFPLFNBQVBBLElBQU8sR0FBTTtBQUNmLFlBQUlQLElBQUlFLGlCQUFKLElBQXlCRixJQUFJRSxpQkFBSixDQUFzQk0sWUFBdEIsSUFBc0NULE1BQS9ELElBQXlFQyxJQUFJSyxhQUE3RSxJQUE4RkwsSUFBSU0sYUFBdEcsRUFBcUg7QUFDakhOLGdCQUFJSyxhQUFKLENBQWtCSSxLQUFsQixDQUF3QkMsT0FBeEIsR0FBa0MsTUFBbEM7QUFDQVYsZ0JBQUlNLGFBQUosQ0FBa0JHLEtBQWxCLENBQXdCQyxPQUF4QixHQUFrQyxNQUFsQztBQUNIO0FBQ0QsWUFBSVYsSUFBSUUsaUJBQUosSUFBeUJGLElBQUlFLGlCQUFKLENBQXNCTSxZQUF0QixHQUFxQ1QsTUFBOUQsSUFBd0VDLElBQUlLLGFBQTVFLElBQTZGTCxJQUFJTSxhQUFyRyxFQUFvSDtBQUNoSE4sZ0JBQUlLLGFBQUosQ0FBa0JNLGdCQUFsQixDQUFtQyxPQUFuQyxFQUE0QyxZQUFNO0FBQzlDWCxvQkFBSUssYUFBSixDQUFrQk8sc0JBQWxCLENBQXlDSCxLQUF6QyxDQUErQ0ksUUFBL0MsR0FBMEQsTUFBMUQ7QUFDQWIsb0JBQUlLLGFBQUosQ0FBa0JPLHNCQUFsQixDQUF5Q0gsS0FBekMsQ0FBK0NWLE1BQS9DLEdBQXdELE1BQXhEO0FBQ0FDLG9CQUFJSyxhQUFKLENBQWtCSSxLQUFsQixDQUF3QkMsT0FBeEIsR0FBa0MsTUFBbEM7QUFDQVYsb0JBQUlNLGFBQUosQ0FBa0JHLEtBQWxCLENBQXdCQyxPQUF4QixHQUFrQyxPQUFsQztBQUNILGFBTEQ7QUFNQVYsZ0JBQUlNLGFBQUosQ0FBa0JLLGdCQUFsQixDQUFtQyxPQUFuQyxFQUE0QyxZQUFNO0FBQzlDWCxvQkFBSU0sYUFBSixDQUFrQk0sc0JBQWxCLENBQXlDQSxzQkFBekMsQ0FBZ0VILEtBQWhFLENBQXNFVixNQUF0RSxHQUErRUEsU0FBTyxJQUF0RjtBQUNBQyxvQkFBSU0sYUFBSixDQUFrQk0sc0JBQWxCLENBQXlDQSxzQkFBekMsQ0FBZ0VILEtBQWhFLENBQXNFSSxRQUF0RSxHQUFpRixRQUFqRjtBQUNBYixvQkFBSU0sYUFBSixDQUFrQkcsS0FBbEIsQ0FBd0JDLE9BQXhCLEdBQWtDLE1BQWxDO0FBQ0FWLG9CQUFJSyxhQUFKLENBQWtCSSxLQUFsQixDQUF3QkMsT0FBeEIsR0FBa0MsT0FBbEM7QUFDSCxhQUxEO0FBTUg7QUFDSixLQW5CRDs7QUFxQkE7OztBQUdBLFFBQU1JLE9BQU8sU0FBUEEsSUFBTyxHQUFNO0FBQ2ZiO0FBQ0FNO0FBQ0gsS0FIRDs7QUFLQU87QUFFSCxDQS9DRDtrQkFnRGVoQixpQiIsImZpbGUiOiJ0b2dnbGVNb3JlQW5kTGVzcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHRvZ2dsZU1vcmVBbmRMZXNzID0gKGhlaWdodCkgPT4ge1xuICAgICd1c2Ugc3RyaWN0JztcbiAgICBsZXQgZWxzID0ge307XG5cbiAgICAvKipcbiAgICAgKiBDYWNoZSBET00gZWxlbWVudHNcbiAgICAgKiovXG4gICAgY29uc3QgZG9tID0gKCkgPT4ge1xuICAgICAgICBlbHMudG9nZ2xlTW9yZUNvbnRlbnQgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKCcuanMtdG9nZ2xlLW1vcmUtY29udGVudCcpO1xuICAgICAgICBlbHMudG9nZ2xlTW9yZUJ0biA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoJy5qcy10b2dnbGUtbW9yZS1idG4nKTtcbiAgICAgICAgZWxzLnRvZ2dsZUxlc3NCdG4gPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKCcuanMtdG9nZ2xlLWxlc3MtYnRuJyk7XG4gICAgfTtcblxuICAgIC8qKlxuICAgICAqIEJpbmQgZXZlbnRzXG4gICAgICoqL1xuICAgIGNvbnN0IGJpbmQgPSAoKSA9PiB7XG4gICAgICAgIGlmIChlbHMudG9nZ2xlTW9yZUNvbnRlbnQgJiYgZWxzLnRvZ2dsZU1vcmVDb250ZW50LmNsaWVudEhlaWdodCA8PSBoZWlnaHQgJiYgZWxzLnRvZ2dsZU1vcmVCdG4gJiYgZWxzLnRvZ2dsZUxlc3NCdG4pIHtcbiAgICAgICAgICAgIGVscy50b2dnbGVNb3JlQnRuLnN0eWxlLmRpc3BsYXkgPSAnbm9uZSc7XG4gICAgICAgICAgICBlbHMudG9nZ2xlTGVzc0J0bi5zdHlsZS5kaXNwbGF5ID0gJ25vbmUnO1xuICAgICAgICB9XG4gICAgICAgIGlmIChlbHMudG9nZ2xlTW9yZUNvbnRlbnQgJiYgZWxzLnRvZ2dsZU1vcmVDb250ZW50LmNsaWVudEhlaWdodCA+IGhlaWdodCAmJiBlbHMudG9nZ2xlTW9yZUJ0biAmJiBlbHMudG9nZ2xlTGVzc0J0bikge1xuICAgICAgICAgICAgZWxzLnRvZ2dsZU1vcmVCdG4uYWRkRXZlbnRMaXN0ZW5lcihcImNsaWNrXCIsICgpID0+IHtcbiAgICAgICAgICAgICAgICBlbHMudG9nZ2xlTW9yZUJ0bi5wcmV2aW91c0VsZW1lbnRTaWJsaW5nLnN0eWxlLm92ZXJmbG93ID0gJ25vbmUnO1xuICAgICAgICAgICAgICAgIGVscy50b2dnbGVNb3JlQnRuLnByZXZpb3VzRWxlbWVudFNpYmxpbmcuc3R5bGUuaGVpZ2h0ID0gJ2F1dG8nO1xuICAgICAgICAgICAgICAgIGVscy50b2dnbGVNb3JlQnRuLnN0eWxlLmRpc3BsYXkgPSAnbm9uZSc7XG4gICAgICAgICAgICAgICAgZWxzLnRvZ2dsZUxlc3NCdG4uc3R5bGUuZGlzcGxheSA9ICdibG9jayc7XG4gICAgICAgICAgICB9KVxuICAgICAgICAgICAgZWxzLnRvZ2dsZUxlc3NCdG4uYWRkRXZlbnRMaXN0ZW5lcihcImNsaWNrXCIsICgpID0+IHtcbiAgICAgICAgICAgICAgICBlbHMudG9nZ2xlTGVzc0J0bi5wcmV2aW91c0VsZW1lbnRTaWJsaW5nLnByZXZpb3VzRWxlbWVudFNpYmxpbmcuc3R5bGUuaGVpZ2h0ID0gaGVpZ2h0KydweCc7XG4gICAgICAgICAgICAgICAgZWxzLnRvZ2dsZUxlc3NCdG4ucHJldmlvdXNFbGVtZW50U2libGluZy5wcmV2aW91c0VsZW1lbnRTaWJsaW5nLnN0eWxlLm92ZXJmbG93ID0gJ2hpZGRlbic7XG4gICAgICAgICAgICAgICAgZWxzLnRvZ2dsZUxlc3NCdG4uc3R5bGUuZGlzcGxheSA9ICdub25lJztcbiAgICAgICAgICAgICAgICBlbHMudG9nZ2xlTW9yZUJ0bi5zdHlsZS5kaXNwbGF5ID0gJ2Jsb2NrJztcbiAgICAgICAgICAgIH0pXG4gICAgICAgIH1cbiAgICB9XG5cbiAgICAvKipcbiAgICAgKiBJbml0aWFsaXplIHRoZSBtb2R1bGVcbiAgICAgKi9cbiAgICBjb25zdCBpbml0ID0gKCkgPT4ge1xuICAgICAgICBkb20oKTtcbiAgICAgICAgYmluZCgpO1xuICAgIH07XG5cbiAgICBpbml0KCk7XG5cbn1cbmV4cG9ydCBkZWZhdWx0IHRvZ2dsZU1vcmVBbmRMZXNzO1xuIl19
},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toTop = toTop;
exports.dropdownMenu = dropdownMenu;
exports.headerFixed = headerFixed;
exports.initBanner = initBanner;
exports.getFormatedPrice = getFormatedPrice;
exports.getCurrency = getCurrency;
exports.getSeparator = getSeparator;
exports.hasScrollToTop = hasScrollToTop;
exports.popitup = popitup;
exports.backToTop = backToTop;
exports.changePlaceholderAndLabelForTheLogin = changePlaceholderAndLabelForTheLogin;
exports.toggleLoginPlaceholderAndLabel = toggleLoginPlaceholderAndLabel;
exports.closeModal = closeModal;
exports.zoomModalPhoto = zoomModalPhoto;
exports.zoomModalMultiPhotos = zoomModalMultiPhotos;
exports.loadProductSameday = loadProductSameday;
exports.ufToggleClassElement = ufToggleClassElement;
exports.thumbnailProduct = thumbnailProduct;
exports.selectSizeCustomByRadio = selectSizeCustomByRadio;
exports.clickOnCatalogMobileProduct = clickOnCatalogMobileProduct;
exports.loadProductParis = loadProductParis;
exports.lazyLoadingImg = lazyLoadingImg;
exports.isIOS = isIOS;
exports.clickOnCheckboxInputReadOnly = clickOnCheckboxInputReadOnly;
exports.getParentNode = getParentNode;

var _cookieconsent = require('cookieconsent');

var _cookieconsent2 = _interopRequireDefault(_cookieconsent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

if (window.jQuery === undefined) {
    window.jQuery = window.$ = require('jquery');
}
function toTop(element) {
    if ($(element).length) {
        var scrollTrigger = 300,
            // px
        _backToTop = function _backToTop() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger) {
                $(element).addClass('show');
            } else {
                $(element).removeClass('show');
            }
        };

        _backToTop();
        $(window).on('scroll', function () {
            _backToTop();
        });

        $(element).on('click', function () {
            $('html,body').animate({
                scrollTop: 0
            }, 700);
        });
    }
}

function dropdownMenu() {
    $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).parent().siblings().removeClass('open');
        $(this).parent().toggleClass('open');
    });
    $('.js-dropdown-last-item>a').on('click', function () {
        var $el = $(this);
        if ($el.length && $el.attr('href')) {
            location.href = $el.attr('href');
        }
    });
}

function headerFixed() {
    var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var headerFixed = document.querySelector('.js-header-fixed');
    var body = document.querySelector('.js-body');

    if (enabled && headerFixed) {
        window.addEventListener('scroll', function () {
            var headerHeight = headerFixed.offsetHeight;

            if (window.scrollY > 0) {
                headerFixed.classList.add('header-fixed');
                body.style.paddingTop = headerHeight + 'px';
            } else {
                headerFixed.classList.remove('header-fixed');
                body.style.paddingTop = '';
            }
        });
    }
}

function initBanner() {
    window.cookieconsent.initialise({
        "theme": "aqua",
        "position": "bottom-right",
        "content": {
            "message": window.AQUA.BANNER_MESSAGE,
            "dismiss": window.AQUA.BANNER_DISMISS,
            "link": window.AQUA.BANNER_LINK,
            "href": window.AQUA.BANNER_HREF
        },
        "cookie": {
            "domain": window.AQUA.BANNER_DOMAIN
        }
    });
}

function getFormatedPrice(locale, currency, price) {
    if (locale === 'en') {
        return window.AQUA.PARTNER === '12' ? getFormatedPriceOalr(price, currency) : currency + price;
    } else {
        return price + '\xa0' + currency;
    }
}

function getFormatedPriceOalr(price, currency) {
    var priceSplited = price.replace(',', '.').split('.');
    return '<span class="format-price">' + currency + priceSplited[0] + '</span>';
}

function getCurrency(initCurrency) {
    var currency = '';
    if (initCurrency === 'EUR') {
        currency = '€';
    } else if (initCurrency === 'CHF') {
        currency = 'CHF';
    } else if (initCurrency === 'USD') {
        currency = '$';
    } else if (initCurrency === 'GBP') {
        currency = 'GBP';
    }

    return currency;
}

function getSeparator(initCurrency) {
    var separator = '';
    if (initCurrency === 'EUR') {
        separator = ',';
    } else if (initCurrency === 'CHF') {
        separator = ',';
    } else if (initCurrency === 'USD') {
        separator = '.';
    } else if (initCurrency === 'GBP') {
        separator = '.';
    }

    return separator;
}

function hasScrollToTop() {
    $('.navigation a').on('click', function () {
        var page = $(this).attr('href');
        var speed = 750;
        $('html, body').animate({ scrollTop: $(page).offset().top }, speed);
        return false;
    });
}

function popitup(url) {
    var newWindow = window.open(url, 'name', 'height=600,width=500');
    if (window.focus) {
        newWindow.focus();
    }
    return false;
}

function backToTop(element) {
    if ($(element).length) {
        var scrollTrigger = 300,
            // px
        _backToTop2 = function _backToTop2() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger) {
                $(element).addClass('show');
            } else {
                $(element).removeClass('show');
            }
        };

        _backToTop2();
        $(window).on('scroll', function () {
            _backToTop2();
        });

        $(element).on('click', function () {
            $('html,body').animate({
                scrollTop: 0
            }, 700);
        });
    }
}

function changePlaceholderAndLabelForTheLogin() {

    var $label = $('.connect-form .username-label-js');
    var $input = $('.connect-form #username');
    var $inputMobile = $('.connect-form #mobile-username');
    var $Registerbtn = $('.js-register-account-btn');
    var $resetPasswordLink = $('.js-reset-password-link');
    var hrefResetPasswordLink = $resetPasswordLink.attr('href');

    $('input:radio[name=_type]').on('change', function () {
        changeLoginLabel(this, $label, $input, $inputMobile);
        changeRegisterButton(this, $Registerbtn);
        changeResetPassword(this, $resetPasswordLink, hrefResetPasswordLink);
    });

    if (location.href.split('?')[1] !== undefined && location.href.split('?')[1] === 'mode=register') {
        $("button[data-target='#modal-create-account']").trigger('click');
    }

    $('input:radio[name=_type][checked]').each(function () {
        changeLoginLabel(this, $label, $input, $inputMobile);
    });
}

function toggleLoginPlaceholderAndLabel(forms) {
    forms.forEach(function (form) {
        var usernameLabel = $(form.querySelector('.username-label-js'));
        var usernameInput = $(form.querySelector('.username-input-js'));

        [].concat(_toConsumableArray(form.querySelectorAll('input[type=radio][name=_type]'))).forEach(function (input) {
            input.addEventListener('change', function (event) {
                changeLoginLabel(input, usernameLabel, usernameInput, usernameInput);
            });

            if (input.checked) {
                changeLoginLabel(input, usernameLabel, usernameInput, usernameInput);
            }
        });
    });
}

function closeModal(element) {
    $(element).on('click', function () {
        ufToggleClassElement('active', [$(this).parent()]);
    });
}

function zoomModalPhoto() {
    var modalPhoto = document.querySelector('.js-modal-photo');
    var modalPhotoZoom = document.querySelector('.js-modal-photo-zoom');
    var modalClosePhoto = document.querySelector('.js-modal-photo-close');

    if (modalPhoto && modalPhotoZoom && modalClosePhoto) {
        modalPhoto.addEventListener('click', function () {
            modalPhotoZoom.style.display = "block";
            modalPhotoZoom.classList.add("in");
        });
        modalClosePhoto.addEventListener("click", function () {
            modalPhotoZoom.style.display = "none";
        });
    }
}

function zoomModalMultiPhotos() {
    var modalPhotos = document.querySelectorAll('.js-modal-multi-photo');
    var modalPhotoZoom = document.querySelector('.js-modal-multi-photo-zoom');
    var modalClosePhoto = document.querySelector('.js-modal-multi-photo-close');
    var modalImg = document.querySelector('.js-modal-multi-photo-zoom .resume-order__img');

    if (modalPhotos) {
        modalPhotos.forEach(function (modalPhoto, iteration) {
            var modalPhotoId = modalPhoto.dataset.photoId;
            modalPhoto.addEventListener('click', function () {
                if (iteration > 0) {
                    modalImg.src = modalImg.src.replace('.jpg', '-' + modalPhotoId + '.jpg');
                }
                modalPhotoZoom.style.display = "block";
                modalPhotoZoom.classList.add("in");
            });
            modalClosePhoto.addEventListener("click", function () {
                if (iteration > 0) {
                    modalImg.src = modalImg.src.replace('-' + modalPhotoId + '.jpg', '.jpg');
                }
                modalPhotoZoom.style.display = "none";
            });
        });
    }
}

function loadProductSameday() {
    var modalSamedayCatalog = '#modal-sameday-catalog';
    var modalSamedayBody = '#modal-sameday-catalog .modal-body';

    $(modalSamedayCatalog).on('show.bs.modal', function () {
        if ($(modalSamedayCatalog + ' section[data-section=catalog]').length == 0) {
            $.ajax({
                url: window.AQUA.URL_LOAD_SAMEDAY
            }).done(function (response) {
                $(modalSamedayBody).html(response);
                $(modalSamedayBody + ' article').on('click', function () {
                    if ($(this).find('a.btn-commander.btn-commander-js').is(':hidden')) {
                        location.href = $(this).find('div.product-button a').attr('href');
                    }
                });
            });
        }
    });
}

function ufToggleClassElement(element, targets) {
    $(targets).each(function (key) {
        $(targets[key]).toggleClass(element);
    });
}

// Protected, don't touch !
function changeLoginLabel(context, $label, $input, $inputMobile) {
    if (context !== undefined) {
        if (context.value == 1) {
            $label.html(window.AQUA.AUTH.TRANSLATIONS.EMAIL_LABEL);
            $input.attr({ placeholder: window.AQUA.AUTH.TRANSLATIONS.EMAIL_PLACEHOLDER });
            $inputMobile.attr({ placeholder: window.AQUA.AUTH.TRANSLATIONS.EMAIL_PLACEHOLDER });
        }

        if (context.value == 2) {
            $label.html(window.AQUA.AUTH.TRANSLATIONS.CODE_LABEL);
            $input.attr({ placeholder: window.AQUA.AUTH.TRANSLATIONS.CODE_PLACEHOLDER });
            $inputMobile.attr({ placeholder: window.AQUA.AUTH.TRANSLATIONS.CODE_PLACEHOLDER });
        }
    }
}

function changeRegisterButton(context, $registerButton) {

    if (context !== undefined) {
        if (context.value == 1) {
            $registerButton.attr({ href: $registerButton.data('private') });
        } else if (context.value == 2) {
            $registerButton.attr({ href: $registerButton.data('business') });
        }
    }
}

function changeResetPassword(context, $resetPasswordLink, hrefResetPasswordLink) {

    if (context !== undefined) {
        if (context.value == 1) {
            $resetPasswordLink.attr({ href: hrefResetPasswordLink + "?b2b=0" });
        } else if (context.value == 2) {
            $resetPasswordLink.attr({ href: hrefResetPasswordLink + "?b2b=1" });
        }
    }
}

function thumbnailProduct() {

    var modalImageProductId = '#modal-img-produit';

    $(document).on('click', '.more', function () {
        ufToggleClassElement('active', [$(this), $(this).prev()]);
    });

    $(document).on('click', '.hide-full-txt', function () {
        ufToggleClassElement('active', [$(this).parent(), $(this).parent().next()]);
    });

    $(document).on('click', ".zoom", function () {
        $(modalImageProductId + ' .modal-body').html('<img src="' + $(this).attr("data-img") + '" />');
        $(modalImageProductId).modal('show');
    });
}

function selectSizeCustomByRadio(element) {
    var radios = document.querySelectorAll(element);
    if (radios.length) {
        radios.forEach(function (radio) {
            radio.addEventListener('click', function (event) {
                var targetRadio = radio.getAttribute("data-target");
                var radioContainer = event.currentTarget.closest('.price-radio');

                if (document.querySelectorAll('input#' + targetRadio).length) {
                    var previousRadioSelected = radioContainer.querySelector(element + '.radio-selected');
                    previousRadioSelected.classList.remove('radio-selected');
                    event.currentTarget.classList.add('radio-selected');

                    radioContainer.querySelectorAll('input[type="radio"]').forEach(function (radioInput) {
                        radioInput.checked = false;
                        if (radioInput.getAttribute('id') === targetRadio) {
                            radioInput.checked = true;
                        }
                    });
                }
            });
        });
    }
}

function clickOnCatalogMobileProduct() {
    $('section[data-section="catalog"] article').on('click', function (e) {
        if ($(this).find('a.btn-commander.btn-commander-js').is(':hidden')) location.href = $(this).find('div.product-button a').attr('href');
    });
}

function loadProductParis() {
    var popup = '#paris-popup.event_warning';
    var modalCatalog = '#modal-paris-catalog';
    var modalBody = '#modal-paris-catalog .modal-body';

    if (document.body.clientWidth >= 769 && $(popup).length == 1) {
        $(popup).css('top', $('table').position().top - $('.block-sameday').outerHeight());
    }

    $(modalCatalog).on('show.bs.modal', function () {
        if ($(modalCatalog + ' section[data-section=catalog]').length == 0) {
            $.ajax({
                url: window.AQUA.URL_LOAD_PARIS
            }).done(function (response) {
                $(modalBody).html(response);
                $(modalBody + ' article').on('click', function () {
                    if ($(this).find('a.btn-commander.btn-commander-js').is(':hidden')) {
                        location.href = $(this).find('div.product-button a').attr('href');
                    }
                });
            });
        }
    });
}

function lazyLoadingImg(imgElement) {
    var options = {
        root: null,
        rootMargin: '120px 0px',
        threshold: 0
    };

    if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    getPicture(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, options);

        [].concat(_toConsumableArray(document.querySelectorAll(imgElement))).forEach(function (img) {
            if (img.nodeName === "IMG" && img !== null) {
                observer.observe(img);
            }
        });
    } else {
        var img = document.querySelectorAll(imgElement);
        for (var i = 0; i < img.length; i++) {
            getPicture(img[i]);
        }
    }
}

function getPicture(element) {
    element.src = element.attributes["data-src"] ? element.attributes["data-src"].value : element.src;
    element.srcset = element.attributes["data-srcset"] ? element.attributes["data-srcset"].value : element.srcset;
    element.removeAttribute("data-src");
    element.removeAttribute("data-srcset");
}

function isIOS() {
    var onlySafari = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var userAgent = navigator.userAgent;
    var Safari = onlySafari === true ? userAgent.match(/Safari/i) !== null : true;
    var AppleDevices = ['iPhone', 'IOS', 'Ipod'];

    return AppleDevices.some(function (device) {
        return userAgent.match(new RegExp(device, 'i')) && Safari;
    });
}

function clickOnCheckboxInputReadOnly(label, inputReadOnly, inputCheckbox) {
    label = document.querySelector(label);
    inputReadOnly = document.querySelector(inputReadOnly);
    inputCheckbox = document.querySelector(inputCheckbox);

    if (label) {
        label.addEventListener('click', function () {
            inputCheckbox.checked === false ? inputReadOnly.readOnly = true : inputReadOnly.readOnly = false;
        });
    }
}

function getParentNode(node, parentSelector) {
    var found = false;

    while (node != document.body) {
        if (!node) break;

        if (node.classList && node.classList.contains(parentSelector)) {
            found = true;
            break;
        }
        node = node.parentNode;
    }

    if (!found) return false;

    return node;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{"cookieconsent":5,"jquery":6}],4:[function(require,module,exports){
"use strict";

var _utils = require("./components/utils");

var _order = require("./components/order");

var _toggleMoreAndLess = require("./components/toggleMoreAndLess");

var _toggleMoreAndLess2 = _interopRequireDefault(_toggleMoreAndLess);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function () {

    var elementToTop = '.js-back-to-top';
    (0, _utils.backToTop)(elementToTop);

    (0, _utils.headerFixed)(true);

    (0, _order.selectsStatutNotification)(document.querySelector(".js-form-funeral-hour"));
    (0, _order.selectsStatutNotification)(document.querySelector(".js-form-funeral-minute"));
    (0, _order.selectsStatutNotification)(document.querySelector(".js-form-planning-day"));

    (0, _order.inputsStatutNotification)();
    (0, _order.verifSelectInputStatutNotification)();

    (0, _utils.dropdownMenu)();
    (0, _toggleMoreAndLess2.default)(90);
}, false);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZha2VfZjBmNzQ5OTIuanMiXSwibmFtZXMiOlsiZG9jdW1lbnQiLCJhZGRFdmVudExpc3RlbmVyIiwiZWxlbWVudFRvVG9wIiwicXVlcnlTZWxlY3RvciJdLCJtYXBwaW5ncyI6Ijs7QUFBQTs7QUFDQTs7QUFDQTs7Ozs7O0FBRUFBLFNBQVNDLGdCQUFULENBQTBCLGtCQUExQixFQUE4QyxZQUFNOztBQUVoRCxRQUFNQyxlQUFlLGlCQUFyQjtBQUNBLDBCQUFVQSxZQUFWOztBQUVBLDRCQUFZLElBQVo7O0FBRUEsMENBQTBCRixTQUFTRyxhQUFULENBQXVCLHVCQUF2QixDQUExQjtBQUNBLDBDQUEwQkgsU0FBU0csYUFBVCxDQUF1Qix5QkFBdkIsQ0FBMUI7QUFDQSwwQ0FBMEJILFNBQVNHLGFBQVQsQ0FBdUIsdUJBQXZCLENBQTFCOztBQUVBO0FBQ0E7O0FBRUE7QUFDQSxxQ0FBa0IsRUFBbEI7QUFFSCxDQWpCRCxFQWlCRyxLQWpCSCIsImZpbGUiOiJmYWtlX2YwZjc0OTkyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtiYWNrVG9Ub3AsIGRyb3Bkb3duTWVudSwgaGVhZGVyRml4ZWR9IGZyb20gXCIuL2NvbXBvbmVudHMvdXRpbHNcIjtcbmltcG9ydCB7aW5wdXRzU3RhdHV0Tm90aWZpY2F0aW9uLCBzZWxlY3RzU3RhdHV0Tm90aWZpY2F0aW9uLCB2ZXJpZlNlbGVjdElucHV0U3RhdHV0Tm90aWZpY2F0aW9ufSBmcm9tIFwiLi9jb21wb25lbnRzL29yZGVyXCI7XG5pbXBvcnQgdG9nZ2xlTW9yZUFuZExlc3MgZnJvbSBcIi4vY29tcG9uZW50cy90b2dnbGVNb3JlQW5kTGVzc1wiO1xuXG5kb2N1bWVudC5hZGRFdmVudExpc3RlbmVyKCdET01Db250ZW50TG9hZGVkJywgKCkgPT4ge1xuXG4gICAgY29uc3QgZWxlbWVudFRvVG9wID0gJy5qcy1iYWNrLXRvLXRvcCc7XG4gICAgYmFja1RvVG9wKGVsZW1lbnRUb1RvcCk7XG5cbiAgICBoZWFkZXJGaXhlZCh0cnVlKTtcbiAgICBcbiAgICBzZWxlY3RzU3RhdHV0Tm90aWZpY2F0aW9uKGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoXCIuanMtZm9ybS1mdW5lcmFsLWhvdXJcIikpO1xuICAgIHNlbGVjdHNTdGF0dXROb3RpZmljYXRpb24oZG9jdW1lbnQucXVlcnlTZWxlY3RvcihcIi5qcy1mb3JtLWZ1bmVyYWwtbWludXRlXCIpKTtcbiAgICBzZWxlY3RzU3RhdHV0Tm90aWZpY2F0aW9uKGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoXCIuanMtZm9ybS1wbGFubmluZy1kYXlcIikpO1xuXG4gICAgaW5wdXRzU3RhdHV0Tm90aWZpY2F0aW9uKCk7XG4gICAgdmVyaWZTZWxlY3RJbnB1dFN0YXR1dE5vdGlmaWNhdGlvbigpO1xuXG4gICAgZHJvcGRvd25NZW51KCk7XG4gICAgdG9nZ2xlTW9yZUFuZExlc3MoOTApO1xuXG59LCBmYWxzZSk7XG4iXX0=
},{"./components/order":1,"./components/toggleMoreAndLess":2,"./components/utils":3}],5:[function(require,module,exports){
!function(e){if(!e.hasInitialised){var t={escapeRegExp:function(e){return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")},hasClass:function(e,t){var i=" ";return 1===e.nodeType&&(i+e.className+i).replace(/[\n\t]/g,i).indexOf(i+t+i)>=0},addClass:function(e,t){e.className+=" "+t},removeClass:function(e,t){var i=new RegExp("\\b"+this.escapeRegExp(t)+"\\b");e.className=e.className.replace(i,"")},interpolateString:function(e,t){return e.replace(/{{([a-z][a-z0-9\-_]*)}}/gi,function(e){return t(arguments[1])||""})},getCookie:function(e){var t=("; "+document.cookie).split("; "+e+"=");return t.length<2?void 0:t.pop().split(";").shift()},setCookie:function(e,t,i,n,o,s){var r=new Date;r.setHours(r.getHours()+24*(i||365));var a=[e+"="+t,"expires="+r.toUTCString(),"path="+(o||"/")];n&&a.push("domain="+n),s&&a.push("secure"),document.cookie=a.join(";")},deepExtend:function(e,t){for(var i in t)t.hasOwnProperty(i)&&(i in e&&this.isPlainObject(e[i])&&this.isPlainObject(t[i])?this.deepExtend(e[i],t[i]):e[i]=t[i]);return e},throttle:function(e,t){var i=!1;return function(){i||(e.apply(this,arguments),i=!0,setTimeout(function(){i=!1},t))}},hash:function(e){var t,i,n=0;if(0===e.length)return n;for(t=0,i=e.length;t<i;++t)n=(n<<5)-n+e.charCodeAt(t),n|=0;return n},normaliseHex:function(e){return"#"==e[0]&&(e=e.substr(1)),3==e.length&&(e=e[0]+e[0]+e[1]+e[1]+e[2]+e[2]),e},getContrast:function(e){return e=this.normaliseHex(e),(299*parseInt(e.substr(0,2),16)+587*parseInt(e.substr(2,2),16)+114*parseInt(e.substr(4,2),16))/1e3>=128?"#000":"#fff"},getLuminance:function(e){var t=parseInt(this.normaliseHex(e),16),i=38+(t>>16),n=38+(t>>8&255),o=38+(255&t);return"#"+(16777216+65536*(i<255?i<1?0:i:255)+256*(n<255?n<1?0:n:255)+(o<255?o<1?0:o:255)).toString(16).slice(1)},isMobile:function(){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)},isPlainObject:function(e){return"object"==typeof e&&null!==e&&e.constructor==Object},traverseDOMPath:function(e,i){return e&&e.parentNode?t.hasClass(e,i)?e:this.traverseDOMPath(e.parentNode,i):null}};e.status={deny:"deny",allow:"allow",dismiss:"dismiss"},e.transitionEnd=function(){var e=document.createElement("div"),t={t:"transitionend",OT:"oTransitionEnd",msT:"MSTransitionEnd",MozT:"transitionend",WebkitT:"webkitTransitionEnd"};for(var i in t)if(t.hasOwnProperty(i)&&void 0!==e.style[i+"ransition"])return t[i];return""}(),e.hasTransition=!!e.transitionEnd;var i=Object.keys(e.status).map(t.escapeRegExp);e.customStyles={},e.Popup=function(){var n={enabled:!0,container:null,cookie:{name:"cookieconsent_status",path:"/",domain:"",expiryDays:365,secure:!1},onPopupOpen:function(){},onPopupClose:function(){},onInitialise:function(e){},onStatusChange:function(e,t){},onRevokeChoice:function(){},onNoCookieLaw:function(e,t){},content:{header:"Cookies used on the website!",message:"This website uses cookies to ensure you get the best experience on our website.",dismiss:"Got it!",allow:"Allow cookies",deny:"Decline",link:"Learn more",href:"https://www.cookiesandyou.com",close:"&#x274c;",target:"_blank",policy:"Cookie Policy"},elements:{header:'<span class="cc-header">{{header}}</span>&nbsp;',message:'<span id="cookieconsent:desc" class="cc-message">{{message}}</span>',messagelink:'<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a></span>',dismiss:'<a aria-label="dismiss cookie message" role=button tabindex="0" class="cc-btn cc-dismiss">{{dismiss}}</a>',allow:'<a aria-label="allow cookies" role=button tabindex="0"  class="cc-btn cc-allow">{{allow}}</a>',deny:'<a aria-label="deny cookies" role=button tabindex="0" class="cc-btn cc-deny">{{deny}}</a>',link:'<a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a>',close:'<span aria-label="dismiss cookie message" role=button tabindex="0" class="cc-close">{{close}}</span>'},window:'<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}">\x3c!--googleoff: all--\x3e{{children}}\x3c!--googleon: all--\x3e</div>',revokeBtn:'<div class="cc-revoke {{classes}}">{{policy}}</div>',compliance:{info:'<div class="cc-compliance">{{dismiss}}</div>',"opt-in":'<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>',"opt-out":'<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>'},type:"info",layouts:{basic:"{{messagelink}}{{compliance}}","basic-close":"{{messagelink}}{{compliance}}{{close}}","basic-header":"{{header}}{{message}}{{link}}{{compliance}}"},layout:"basic",position:"bottom",theme:"block",static:!1,palette:null,revokable:!1,animateRevokable:!0,showLink:!0,dismissOnScroll:!1,dismissOnTimeout:!1,dismissOnWindowClick:!1,ignoreClicksFrom:["cc-revoke","cc-btn"],autoOpen:!0,autoAttach:!0,whitelistPage:[],blacklistPage:[],overrideHTML:null};function o(){this.initialise.apply(this,arguments)}function s(e){this.openingTimeout=null,t.removeClass(e,"cc-invisible")}function r(t){t.style.display="none",t.removeEventListener(e.transitionEnd,this.afterTransition),this.afterTransition=null}function a(){var e=this.options.position.split("-"),t=[];return e.forEach(function(e){t.push("cc-"+e)}),t}function c(n){var o=this.options,s=document.createElement("div"),r=o.container&&1===o.container.nodeType?o.container:document.body;s.innerHTML=n;var a=s.children[0];return a.style.display="none",t.hasClass(a,"cc-window")&&e.hasTransition&&t.addClass(a,"cc-invisible"),this.onButtonClick=function(n){var o=t.traverseDOMPath(n.target,"cc-btn")||n.target;if(t.hasClass(o,"cc-btn")){var s=o.className.match(new RegExp("\\bcc-("+i.join("|")+")\\b")),r=s&&s[1]||!1;r&&(this.setStatus(r),this.close(!0))}t.hasClass(o,"cc-close")&&(this.setStatus(e.status.dismiss),this.close(!0));t.hasClass(o,"cc-revoke")&&this.revokeChoice()}.bind(this),a.addEventListener("click",this.onButtonClick),o.autoAttach&&(r.firstChild?r.insertBefore(a,r.firstChild):r.appendChild(a)),a}function l(e){return"000000"==(e=t.normaliseHex(e))?"#222":t.getLuminance(e)}function u(e,t){for(var i=0,n=e.length;i<n;++i){var o=e[i];if(o instanceof RegExp&&o.test(t)||"string"==typeof o&&o.length&&o===t)return!0}return!1}return o.prototype.initialise=function(i){this.options&&this.destroy(),t.deepExtend(this.options={},n),t.isPlainObject(i)&&t.deepExtend(this.options,i),function(){var t=this.options.onInitialise.bind(this);if(!window.navigator.cookieEnabled)return t(e.status.deny),!0;if(window.CookiesOK||window.navigator.CookiesOK)return t(e.status.allow),!0;var i=Object.keys(e.status),n=this.getStatus(),o=i.indexOf(n)>=0;o&&t(n);return o}.call(this)&&(this.options.enabled=!1),u(this.options.blacklistPage,location.pathname)&&(this.options.enabled=!1),u(this.options.whitelistPage,location.pathname)&&(this.options.enabled=!0);var o=this.options.window.replace("{{classes}}",function(){var i=this.options,n="top"==i.position||"bottom"==i.position?"banner":"floating";t.isMobile()&&(n="floating");var o=["cc-"+n,"cc-type-"+i.type,"cc-theme-"+i.theme];i.static&&o.push("cc-static");o.push.apply(o,a.call(this));(function(i){var n=t.hash(JSON.stringify(i)),o="cc-color-override-"+n,s=t.isPlainObject(i);this.customStyleSelector=s?o:null,s&&function(i,n,o){if(e.customStyles[i])return void++e.customStyles[i].references;var s={},r=n.popup,a=n.button,c=n.highlight;r&&(r.text=r.text?r.text:t.getContrast(r.background),r.link=r.link?r.link:r.text,s[o+".cc-window"]=["color: "+r.text,"background-color: "+r.background],s[o+".cc-revoke"]=["color: "+r.text,"background-color: "+r.background],s[o+" .cc-link,"+o+" .cc-link:active,"+o+" .cc-link:visited"]=["color: "+r.link],a&&(a.text=a.text?a.text:t.getContrast(a.background),a.border=a.border?a.border:"transparent",s[o+" .cc-btn"]=["color: "+a.text,"border-color: "+a.border,"background-color: "+a.background],a.padding&&s[o+" .cc-btn"].push("padding: "+a.padding),"transparent"!=a.background&&(s[o+" .cc-btn:hover, "+o+" .cc-btn:focus"]=["background-color: "+(a.hover||l(a.background))]),c?(c.text=c.text?c.text:t.getContrast(c.background),c.border=c.border?c.border:"transparent",s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+c.text,"border-color: "+c.border,"background-color: "+c.background]):s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+r.text]));var u=document.createElement("style");document.head.appendChild(u),e.customStyles[i]={references:1,element:u.sheet};var h=-1;for(var p in s)s.hasOwnProperty(p)&&u.sheet.insertRule(p+"{"+s[p].join(";")+"}",++h)}(n,i,"."+o);return s}).call(this,this.options.palette);this.customStyleSelector&&o.push(this.customStyleSelector);return o}.call(this).join(" ")).replace("{{children}}",function(){var e={},i=this.options;i.showLink||(i.elements.link="",i.elements.messagelink=i.elements.message);Object.keys(i.elements).forEach(function(n){e[n]=t.interpolateString(i.elements[n],function(e){var t=i.content[e];return e&&"string"==typeof t&&t.length?t:""})});var n=i.compliance[i.type];n||(n=i.compliance.info);e.compliance=t.interpolateString(n,function(t){return e[t]});var o=i.layouts[i.layout];o||(o=i.layouts.basic);return t.interpolateString(o,function(t){return e[t]})}.call(this)),s=this.options.overrideHTML;if("string"==typeof s&&s.length&&(o=s),this.options.static){var r=c.call(this,'<div class="cc-grower">'+o+"</div>");r.style.display="",this.element=r.firstChild,this.element.style.display="none",t.addClass(this.element,"cc-invisible")}else this.element=c.call(this,o);(function(){var i=this.setStatus.bind(this),n=this.close.bind(this),o=this.options.dismissOnTimeout;"number"==typeof o&&o>=0&&(this.dismissTimeout=window.setTimeout(function(){i(e.status.dismiss),n(!0)},Math.floor(o)));var s=this.options.dismissOnScroll;if("number"==typeof s&&s>=0){var r=function(t){window.pageYOffset>Math.floor(s)&&(i(e.status.dismiss),n(!0),window.removeEventListener("scroll",r),this.onWindowScroll=null)};this.options.enabled&&(this.onWindowScroll=r,window.addEventListener("scroll",r))}var a=this.options.dismissOnWindowClick,c=this.options.ignoreClicksFrom;if(a){var l=function(o){for(var s=!1,r=o.path.length,a=c.length,u=0;u<r;u++)if(!s)for(var h=0;h<a;h++)s||(s=t.hasClass(o.path[u],c[h]));s||(i(e.status.dismiss),n(!0),window.removeEventListener("click",l),window.removeEventListener("touchend",l),this.onWindowClick=null)}.bind(this);this.options.enabled&&(this.onWindowClick=l,window.addEventListener("click",l),window.addEventListener("touchend",l))}}).call(this),function(){"info"!=this.options.type&&(this.options.revokable=!0);t.isMobile()&&(this.options.animateRevokable=!1);if(this.options.revokable){var e=a.call(this);this.options.animateRevokable&&e.push("cc-animate"),this.customStyleSelector&&e.push(this.customStyleSelector);var i=this.options.revokeBtn.replace("{{classes}}",e.join(" ")).replace("{{policy}}",this.options.content.policy);this.revokeBtn=c.call(this,i);var n=this.revokeBtn;if(this.options.animateRevokable){var o=t.throttle(function(e){var i=!1,o=window.innerHeight-20;t.hasClass(n,"cc-top")&&e.clientY<20&&(i=!0),t.hasClass(n,"cc-bottom")&&e.clientY>o&&(i=!0),i?t.hasClass(n,"cc-active")||t.addClass(n,"cc-active"):t.hasClass(n,"cc-active")&&t.removeClass(n,"cc-active")},200);this.onMouseMove=o,window.addEventListener("mousemove",o)}}}.call(this),this.options.autoOpen&&this.autoOpen()},o.prototype.destroy=function(){this.onButtonClick&&this.element&&(this.element.removeEventListener("click",this.onButtonClick),this.onButtonClick=null),this.dismissTimeout&&(clearTimeout(this.dismissTimeout),this.dismissTimeout=null),this.onWindowScroll&&(window.removeEventListener("scroll",this.onWindowScroll),this.onWindowScroll=null),this.onWindowClick&&(window.removeEventListener("click",this.onWindowClick),this.onWindowClick=null),this.onMouseMove&&(window.removeEventListener("mousemove",this.onMouseMove),this.onMouseMove=null),this.element&&this.element.parentNode&&this.element.parentNode.removeChild(this.element),this.element=null,this.revokeBtn&&this.revokeBtn.parentNode&&this.revokeBtn.parentNode.removeChild(this.revokeBtn),this.revokeBtn=null,function(i){if(t.isPlainObject(i)){var n=t.hash(JSON.stringify(i)),o=e.customStyles[n];if(o&&!--o.references){var s=o.element.ownerNode;s&&s.parentNode&&s.parentNode.removeChild(s),e.customStyles[n]=null}}}(this.options.palette),this.options=null},o.prototype.open=function(t){if(this.element)return this.isOpen()||(e.hasTransition?this.fadeIn():this.element.style.display="",this.options.revokable&&this.toggleRevokeButton(),this.options.onPopupOpen.call(this)),this},o.prototype.close=function(t){if(this.element)return this.isOpen()&&(e.hasTransition?this.fadeOut():this.element.style.display="none",t&&this.options.revokable&&this.toggleRevokeButton(!0),this.options.onPopupClose.call(this)),this},o.prototype.fadeIn=function(){var i=this.element;if(e.hasTransition&&i&&(this.afterTransition&&r.call(this,i),t.hasClass(i,"cc-invisible"))){if(i.style.display="",this.options.static){var n=this.element.clientHeight;this.element.parentNode.style.maxHeight=n+"px"}this.openingTimeout=setTimeout(s.bind(this,i),20)}},o.prototype.fadeOut=function(){var i=this.element;e.hasTransition&&i&&(this.openingTimeout&&(clearTimeout(this.openingTimeout),s.bind(this,i)),t.hasClass(i,"cc-invisible")||(this.options.static&&(this.element.parentNode.style.maxHeight=""),this.afterTransition=r.bind(this,i),i.addEventListener(e.transitionEnd,this.afterTransition),t.addClass(i,"cc-invisible")))},o.prototype.isOpen=function(){return this.element&&""==this.element.style.display&&(!e.hasTransition||!t.hasClass(this.element,"cc-invisible"))},o.prototype.toggleRevokeButton=function(e){this.revokeBtn&&(this.revokeBtn.style.display=e?"":"none")},o.prototype.revokeChoice=function(e){this.options.enabled=!0,this.clearStatus(),this.options.onRevokeChoice.call(this),e||this.autoOpen()},o.prototype.hasAnswered=function(t){return Object.keys(e.status).indexOf(this.getStatus())>=0},o.prototype.hasConsented=function(t){var i=this.getStatus();return i==e.status.allow||i==e.status.dismiss},o.prototype.autoOpen=function(e){!this.hasAnswered()&&this.options.enabled?this.open():this.hasAnswered()&&this.options.revokable&&this.toggleRevokeButton(!0)},o.prototype.setStatus=function(i){var n=this.options.cookie,o=t.getCookie(n.name),s=Object.keys(e.status).indexOf(o)>=0;Object.keys(e.status).indexOf(i)>=0?(t.setCookie(n.name,i,n.expiryDays,n.domain,n.path,n.secure),this.options.onStatusChange.call(this,i,s)):this.clearStatus()},o.prototype.getStatus=function(){return t.getCookie(this.options.cookie.name)},o.prototype.clearStatus=function(){var e=this.options.cookie;t.setCookie(e.name,"",-1,e.domain,e.path)},o}(),e.Location=function(){var e={timeout:5e3,services:["ipinfo"],serviceDefinitions:{ipinfo:function(){return{url:"//ipinfo.io",headers:["Accept: application/json"],callback:function(e,t){try{var i=JSON.parse(t);return i.error?s(i):{code:i.country}}catch(e){return s({error:"Invalid response ("+e+")"})}}}},ipinfodb:function(e){return{url:"//api.ipinfodb.com/v3/ip-country/?key={api_key}&format=json&callback={callback}",isScript:!0,callback:function(e,t){try{var i=JSON.parse(t);return"ERROR"==i.statusCode?s({error:i.statusMessage}):{code:i.countryCode}}catch(e){return s({error:"Invalid response ("+e+")"})}}}},maxmind:function(){return{url:"//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js",isScript:!0,callback:function(e){window.geoip2?geoip2.country(function(t){try{e({code:t.country.iso_code})}catch(t){e(s(t))}},function(t){e(s(t))}):e(new Error("Unexpected response format. The downloaded script should have exported `geoip2` to the global scope"))}}}}};function i(i){t.deepExtend(this.options={},e),t.isPlainObject(i)&&t.deepExtend(this.options,i),this.currentServiceIndex=-1}function n(e,t,i){var n,o=document.createElement("script");o.type="text/"+(e.type||"javascript"),o.src=e.src||e,o.async=!1,o.onreadystatechange=o.onload=function(){var e=o.readyState;clearTimeout(n),t.done||e&&!/loaded|complete/.test(e)||(t.done=!0,t(),o.onreadystatechange=o.onload=null)},document.body.appendChild(o),n=setTimeout(function(){t.done=!0,t(),o.onreadystatechange=o.onload=null},i)}function o(e,t,i,n,o){var s=new(window.XMLHttpRequest||window.ActiveXObject)("MSXML2.XMLHTTP.3.0");if(s.open(n?"POST":"GET",e,1),s.setRequestHeader("Content-type","application/x-www-form-urlencoded"),Array.isArray(o))for(var r=0,a=o.length;r<a;++r){var c=o[r].split(":",2);s.setRequestHeader(c[0].replace(/^\s+|\s+$/g,""),c[1].replace(/^\s+|\s+$/g,""))}"function"==typeof t&&(s.onreadystatechange=function(){s.readyState>3&&t(s)}),s.send(n)}function s(e){return new Error("Error ["+(e.code||"UNKNOWN")+"]: "+e.error)}return i.prototype.getNextService=function(){var e;do{e=this.getServiceByIdx(++this.currentServiceIndex)}while(this.currentServiceIndex<this.options.services.length&&!e);return e},i.prototype.getServiceByIdx=function(e){var i=this.options.services[e];if("function"==typeof i){var n=i();return n.name&&t.deepExtend(n,this.options.serviceDefinitions[n.name](n)),n}return"string"==typeof i?this.options.serviceDefinitions[i]():t.isPlainObject(i)?this.options.serviceDefinitions[i.name](i):null},i.prototype.locate=function(e,t){var i=this.getNextService();i?(this.callbackComplete=e,this.callbackError=t,this.runService(i,this.runNextServiceOnError.bind(this))):t(new Error("No services to run"))},i.prototype.setupUrl=function(e){var t=this.getCurrentServiceOpts();return e.url.replace(/\{(.*?)\}/g,function(i,n){if("callback"===n){var o="callback"+Date.now();return window[o]=function(t){e.__JSONP_DATA=JSON.stringify(t)},o}if(n in t.interpolateUrl)return t.interpolateUrl[n]})},i.prototype.runService=function(e,t){var i=this;e&&e.url&&e.callback&&(e.isScript?n:o)(this.setupUrl(e),function(n){var o=n?n.responseText:"";e.__JSONP_DATA&&(o=e.__JSONP_DATA,delete e.__JSONP_DATA),i.runServiceCallback.call(i,t,e,o)},this.options.timeout,e.data,e.headers)},i.prototype.runServiceCallback=function(e,t,i){var n=this,o=t.callback(function(t){o||n.onServiceResult.call(n,e,t)},i);o&&this.onServiceResult.call(this,e,o)},i.prototype.onServiceResult=function(e,t){t instanceof Error||t&&t.error?e.call(this,t,null):e.call(this,null,t)},i.prototype.runNextServiceOnError=function(e,t){if(e){this.logError(e);var i=this.getNextService();i?this.runService(i,this.runNextServiceOnError.bind(this)):this.completeService.call(this,this.callbackError,new Error("All services failed"))}else this.completeService.call(this,this.callbackComplete,t)},i.prototype.getCurrentServiceOpts=function(){var e=this.options.services[this.currentServiceIndex];return"string"==typeof e?{name:e}:"function"==typeof e?e():t.isPlainObject(e)?e:{}},i.prototype.completeService=function(e,t){this.currentServiceIndex=-1,e&&e(t)},i.prototype.logError=function(e){var t=this.currentServiceIndex,i=this.getServiceByIdx(t);console.warn("The service["+t+"] ("+i.url+") responded with the following error",e)},i}(),e.Law=function(){var e={regionalLaw:!0,hasLaw:["AT","BE","BG","HR","CZ","CY","DK","EE","FI","FR","DE","EL","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","SK","ES","SE","GB","UK","GR","EU"],revokable:["HR","CY","DK","EE","FR","DE","LV","LT","NL","PT","ES"],explicitAction:["HR","IT","ES"]};function i(e){this.initialise.apply(this,arguments)}return i.prototype.initialise=function(i){t.deepExtend(this.options={},e),t.isPlainObject(i)&&t.deepExtend(this.options,i)},i.prototype.get=function(e){var t=this.options;return{hasLaw:t.hasLaw.indexOf(e)>=0,revokable:t.revokable.indexOf(e)>=0,explicitAction:t.explicitAction.indexOf(e)>=0}},i.prototype.applyLaw=function(e,t){var i=this.get(t);return i.hasLaw||(e.enabled=!1,"function"==typeof e.onNoCookieLaw&&e.onNoCookieLaw(t,i)),this.options.regionalLaw&&(i.revokable&&(e.revokable=!0),i.explicitAction&&(e.dismissOnScroll=!1,e.dismissOnTimeout=!1)),e},i}(),e.initialise=function(i,n,o){var s=new e.Law(i.law);n||(n=function(){}),o||(o=function(){});var r=Object.keys(e.status),a=t.getCookie("cookieconsent_status");r.indexOf(a)>=0?n(new e.Popup(i)):e.getCountryCode(i,function(t){delete i.law,delete i.location,t.code&&(i=s.applyLaw(i,t.code)),n(new e.Popup(i))},function(t){delete i.law,delete i.location,o(t,new e.Popup(i))})},e.getCountryCode=function(t,i,n){t.law&&t.law.countryCode?i({code:t.law.countryCode}):t.location?new e.Location(t.location).locate(function(e){i(e||{})},n):i({})},e.utils=t,e.hasInitialised=!0,window.cookieconsent=e}}(window.cookieconsent||{});
},{}],6:[function(require,module,exports){
/*!
 * jQuery JavaScript Library v3.4.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2019-05-01T21:04Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.4.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code, options ) {
		DOMEval( code, { nonce: options && options.nonce } );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.4
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2019-04-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) &&

				// Support: IE 8 only
				// Exclude object elements
				(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 && rdescend.test( selector ) ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = (elem.ownerDocument || elem).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( typeof elem.contentDocument !== "undefined" ) {
			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								} );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	// Support: IE 9-11 only
	// Also use offsetWidth/offsetHeight for when box sizing is unreliable
	// We use getClientRects() to check for hidden/disconnected.
	// In those cases, the computed value can be trusted to be border-box
	if ( ( !support.boxSizingReliable() && isBorderBox ||
		val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url, options ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );

},{}]},{},[4])